import React from 'react'
import { Box, Table, TableHead, TableBody, TableRow, TableCell, Hidden, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import Moment from 'react-moment'
import { PropTourList } from '../../../../types/default-types'
import { PaginationCustom } from '../../../../components'

export const TourList: React.FC<PropTourList> = ({
  data = [],
  last_page,
  per_page,
  total,
  page,
  stage,
  changePage,
}): JSX.Element => {
  const classes = useStyles()

  return (
    <>
      <Box width="100%" sx={{ overflowX: { xs: 'scroll', md: 'auto' } }}>
        <Table id="winnersTable" className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>Команда/Имя</TableCell>
              {stage < 3 && <TableCell>Город</TableCell>}
              {stage === 1 && <TableCell>Ресторан</TableCell>}
              <TableCell>Номинация</TableCell>
              <TableCell>Статус</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item, index) => (
              <TableRow className="tr" key={index}>
                <TableCell>
                  {item.userName ? (
                    <Box textAlign="left">{item.userName}</Box>
                  ) : (
                    <Box textAlign="left">
                      <Box fontSize="110%" fontWeight={700} color="#FFFFFF" mb={1}>
                        {item.commandName}
                      </Box>
                      {item.commandUser &&
                        item.commandUser.map((items: any) => {
                          return <Box>{items}</Box>
                        })}
                    </Box>
                  )}
                </TableCell>
                {stage < 3 && <TableCell>{item.city}</TableCell>}
                {stage === 1 && <TableCell>{item.subdivision}</TableCell>}
                <TableCell>{item.nomination}</TableCell>
                <TableCell>{item.status}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
      {total > per_page && (
        <Box py={4} width="100%" display="flex" justifyContent="center">
          <PaginationCustom count={last_page} page={page + 1} onChange={changePage} />
        </Box>
      )}
    </>
  )
}

const useStyles = makeStyles(({ spacing, font, breakpoints: { down }, palette }: Theme) => ({
  table: {
    minWidth: 650,
    [down('md')]: {
      minWidth: 960,
    },
    [down('sm')]: {
      minWidth: 600,
    },
  },
}))
